import React from 'react'
import styled from 'styled-components';


const Footer = () => {
    return (
        <FooterContainer>
            <p>© {new Date().getFullYear()} Wildberries AS. Alle rettigheter reservert.</p>
            <p>Utviklet av 
                <StyledLink href="https://saidsolsaev.site" target="_blank" rel="noopener noreferrer">Said Solsaev</StyledLink>
            </p>
        </FooterContainer>
    );
}

export default Footer

const FooterContainer = styled.footer`
    background: #2d6a4f;
    text-align: center;
    padding: 15px;
    border-top: 2px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0px -3px 8px rgba(0, 0, 0, 0.1);

    p {
        color: white;
        font-size: .9rem;
        font-weight: 300;
    }
`;

const StyledLink = styled.a`
    color: #a8dadc;
    text-decoration: none;
    font-weight: 500;
    position: relative;
    display: inline-block;
    margin-left: 6px;

    &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: -2px;
        width: 0;
        height: 2px;
        background: #a8dadc;
        transition: width 0.3s ease-in-out;
    }

    &:hover::after {
        width: 100%;
    }
`;